<template>
  <div
    id="lm-filter"
    @keydown.esc="closeContent"
    >
    <button v-b-toggle.sidebar-filter type="button" class="btn btn-secondary btn-secondary-custom">
      <font-awesome-icon icon="sliders-h" />
      <span class="filter">{{ toggleContentButtonText }}</span>
      <i class="noti-icon-badge" v-if="aggregatesSelected.length"/>
      <span
        class="selected-aggregate d-inline-flex justify-content-center align-items-center ml-1"
        v-if="aggregatesSelected.length"
      >
        {{aggregatesSelected.length}}
      </span>
    </button>
    <b-sidebar
      ref="bSidebar"
      id="sidebar-filter"
      bg-variant="muted"
      right
      no-close-on-route-change
      shadow
      >
      <div class="px-3 py-2">
        <LmComponentLoading v-if="loading" :top="0" :backgroundColor="{ background: '#dee2e6' }" />
        <template v-for="(selectedAgregate) in aggregatesSelected">
          <button
            v-for="(value, key) in selectedAgregate"
            :key="`value-${key}`"
            class="btn btn-link remove-aggregate mr-2 mb-2 d-inline-flex align-items-center js-no-hide-click-outside"
            v-b-tooltip.hover="value"
            @click="unSelectAggregate(key, value)"
            >
              <span class="js-no-hide-click-outside">{{ value }}</span>
              <font-awesome-icon icon="times" class="js-no-hide-click-outside" />
          </button>
        </template>
        <button
          v-if="aggregatesSelected.length"
          class="btn btn-link pl-0 d-block js-no-hide-click-outside"
          @click="cleanAllSelectedAgregates">{{$t('clean_filters')}}</button>
        <h4 v-if="totalResult">Resultados Obtenidos: {{totalResult}}</h4>
        <template v-for="(aggregate, key, index) in aggregates">
          <div
            :key="`aggregate-${index}`"
            class="aggregates"
            v-if="aggregate.frontEndVisiblity"
            >
              <h4>{{ keyReadableForHuman(key) }}</h4>
              <ul>
                <li
                  @click="filterByAggregate({[key]: el.label})"
                  v-for="(el, index) in aggregate.content"
                  :key="`el-${index}`"
                  class="d-none"
                  :class="{'d-block': aggregates[key].showAll | showAllAggregates(index)}"
                  >
                  <span class="aggregates__label">{{ el.label }}</span>
                  <span class="aggregates__count">({{el.count}})</span>
                </li>
              </ul>
              <button
                class="btn btn-link p-0 see-more-button"
                v-if="mustShowSeeMoreButton(aggregate.content.length)"
                @click="seeMore(key)">
                  {{ aggregates[key].showAll ? 'Ver menos' : 'Ver más' }}
              </button>
          </div>
        </template>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import urlQueryBuilder from '@/mixins/urlQueryBuilder.js'
import keyReadableForHuman from '@/helpers/key-readable-for-humans.js'
export default {
  mixins: [urlQueryBuilder],
  data () {
    return {
      isContentShow: false,
      loading: false,
      aggregatesSelected: []
    }
  },
  props: {
    aggregatesSelectedProp: {
      type: Array,
      default: () => []
    },
    showMoreAggregatesItemsAt: {
      type: Number,
      default: Number(process.env.VUE_APP_SHOW_MORE_AGGREGATES_ITEMS_AT) || 30
    },
    aggregates: {
      type: Object,
      default: () => ({})
    },
    loadingProp: {
      type: Boolean,
      default: false
    },
    totalResult: {
      type: Number,
      default: 0
    }
  },
  computed: {
    toggleContentButtonText () {
      return this.isContentShow ? this.$t('hide_filters') : this.$t('show_filters')
    }
  },
  watch: {
    loadingProp () {
      this.loading = this.loadingProp
    },
    aggregatesSelectedProp () {
      this.aggregatesSelected = this.aggregatesSelectedProp
    }
  },
  created () {
    this.aggregatesSelected = this.aggregatesSelectedProp
  },
  methods: {
    hide () {
      this.$refs.bSidebar.hide()
    },
    mustShowSeeMoreButton (aggregateItemLength) {
      return aggregateItemLength > this.showMoreAggregatesItemsAt
    },
    seeMore (key) {
      if (!this.aggregates[key].showAll) {
        this.$set(this.aggregates[key], 'showAll', true)
      } else {
        this.aggregates[key].showAll = false
      }
    },
    urlQueryBuilderAgregates () {
      this.urlQueryBuilder({ page: null })
      this.urlQueryBuilder({ aggregates: JSON.stringify(this.aggregatesSelected) })
    },
    unSelectAggregate (event) {
      this.aggregatesSelected.splice(event, 1)
      this.urlQueryBuilderAgregates()
    },
    cleanAllSelectedAgregates () {
      this.aggregatesSelected = []
      this.urlQueryBuilderAgregates()
    },
    filterByAggregate (aggregate) {
      this.aggregatesSelected.push(aggregate)
      this.urlQueryBuilderAgregates()
    },
    showAllAggregates (filterIndex) {
      const result = filterIndex < this.showMoreAggregatesItemsAt
      return result
    },
    toggleContent () {
      this.isContentShow = !this.isContentShow
    },
    keyReadableForHuman (key) {
      return keyReadableForHuman(key)
    }
  }
}
</script>

<style lang="sass" scoped>
#lm-filter
  position: relative
  .btn-secondary-custom
    color: #6c757d
    background-color: #fff
    border-color: #ced4da
    &:active,
    &:not(:disabled):not(.disabled):active,
    &.btn-secondary:not(:disabled):not(.disabled).active,
    &.show > .btn-secondary.dropdown-toggle
      color: #6c757d
      background-color: #fff
      border-color: #ced4da
      outline: none
    &:focus
      box-shadow: 0 2px 6px 0 rgba(108, 117, 125, 0.5) !important
  .noti-icon-badge
    display: inline-block
    position: absolute
    top: 8px
    left: 10px
    border-radius: 50%
    height: 7px
    width: 7px
    background-color: #fa5c7c
  .filter
    margin-left: 10px
  .active
    background: white
  .selected-aggregate
    border-radius: 50%
    color: white
    background: $dangerThemeColor
    font-weight: 700
    font-size: 12px
    width: 22px
    height: 22px
::v-deep
  #sidebar-filter
    background: #dee2e6
    .remove-aggregate
      color: $primaryFontThemeColor
      background: white
    span
      margin-right: 10px
      white-space: nowrap
      max-width: 185px
      overflow: hidden
      text-overflow: ellipsis
      text-align: left
    .aggregates
      cursor: pointer
      li
        word-break: break-all
      .aggregates__count
        color: #999ea2
        margin-left: 5px
      .see-more-button
        margin-top: -28px
</style>
